import { EmptyState, FlexColumn, Loading } from '@gorila-shared-ui/components';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from 'react-window';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { MEDIA_POSITION_ORIGIN } from '../../../../constants/media';
import { useStyles } from '../../../../hooks/useStyles';
import {
  capturingTimelineEventState,
  capturingTimelineState,
  loadingCapturingTimelineState,
} from '../../../../storage/streaming';
import CapturingVideoEventMediaModal from './CapturingVideoEventMediaModal';
import CapturingVideoTrackItem from './CapturingVideoTrackItem';

function CapturingVideoTrackList() {
  const { css, theme } = useStyles();
  const loading = useRecoilValue(loadingCapturingTimelineState);
  const timeline = useRecoilValue(capturingTimelineState);
  const event = useRecoilValue(capturingTimelineEventState);
  const resetEvent = useResetRecoilState(capturingTimelineEventState);

  if (loading) {
    return <Loading />;
  }

  if (!loading && !timeline?.length) {
    return (
      <EmptyState
        title="Sin registros"
        description="No se encontró un trayecto para este día"
      />
    );
  }

  if (!timeline) return null;

  return (
    <FlexColumn classNames={css({ flex: 1 })}>
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'hidden',
          position: 'relative',
          boxSizing: 'border-box',
          flex: 1,
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'hidden',
            height: '100%',
          })}
        >
          <AutoSizer>
            {({ width, height }) => (
              <>
                <div
                  className={css({
                    width: '2px',
                    borderLeft: `2px dotted ${theme.colors.backgroundOverlayLight}`,
                    position: 'absolute',
                    left: '23px',
                    top: '25px',
                    height: 'calc(100% - 50px)',
                  })}
                />
                <List
                  height={height ? height : 500}
                  itemCount={timeline.length}
                  itemSize={(index) => {
                    const record = timeline[index];
                    const filteredEvents = record.events?.filter(
                      (event) => event.mediaOrigin !== MEDIA_POSITION_ORIGIN,
                    );
                    if (filteredEvents?.length) {
                      return 134 + 28 * filteredEvents.length;
                    }
                    return 134;
                  }}
                  width={width ? width : 200}
                  itemData={timeline}
                >
                  {CapturingVideoTrackItem}
                </List>
              </>
            )}
          </AutoSizer>
        </div>
      </div>
      {event && (
        <CapturingVideoEventMediaModal
          event={event}
          onClose={resetEvent}
          isOpen
        />
      )}
    </FlexColumn>
  );
}

export default CapturingVideoTrackList;
